import { useState } from 'react'
import { Modal, ModalHeader, ModalBody, Input } from 'reactstrap'
import { DealEstimatingCosts } from 'components/common/DealEstimatingCosts'
import s from './CreateEstimatingTemplateModal.scss'

const CreateEstimatingTemplateModal = ({
  isModalVisible,
  clearModal,
  editedTemplate,
  saveTemplate
}) => {
  const [name, setName] = useState('')
  const [visibility, setVisibility] = useState('ALL')
  const [prevEditedTemplate, setPrevEditedTemplate] = useState(null)

  if (editedTemplate && editedTemplate !== prevEditedTemplate) {
    setName(editedTemplate.name)
    setVisibility(editedTemplate.visibility)
    setPrevEditedTemplate(editedTemplate)
  }

  return (
    <Modal
      keyboard={false}
      backdrop="static"
      isOpen={isModalVisible}
      toggle={clearModal}
      size="xl"
      className={s.modal}
    >
      <ModalHeader className={s.modalHeader}>
        {editedTemplate ? 'Edit' : 'Add'} Estimate Template
      </ModalHeader>
      <ModalBody className={s.modalBody}>
        <div style={{ marginBottom: '20px' }}>
          <Input
            type="text"
            onChange={({ target }) => setName(target.value)}
            value={name}
            name="name"
            placeholder="Estimate Name"
            className={s.input}
          />
          <div className={s.radioGroup}>
            <label>Visible</label>
            <input
              type="radio"
              checked={visibility === 'ALL'}
              onChange={() => {
                setVisibility('ALL')
              }}
            />{' '}
            Everyone in my org {'  '}
            <input
              type="radio"
              checked={visibility === 'ME'}
              onChange={() => {
                setVisibility('ME')
              }}
              className={s.rightRadio}
            />{' '}
            Just me
          </div>
        </div>
        <DealEstimatingCosts
          createTemplatePageProps={{
            saveTemplate: template => saveTemplate(name, visibility, template),
            canSaveTemplate: !!name,
            clearModal,
            ...(editedTemplate ? { editedTemplate: editedTemplate.template } : {})
          }}
        />
      </ModalBody>
    </Modal>
  )
}

export default CreateEstimatingTemplateModal
